import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form } from 'semantic-ui-react'

import SeguroPermite from '../../../components/funcionales/seguropermite'

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'
var moment = require('moment');

//dropdown EMPRESAS
const DetalleEmpNivel1 = props => {
  // console.log(props.elemento)
  return (
    <option style={props.styles.input}>{props.elemento.descrEmpresa}</option>
  )
}; 

const ListaEmp = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar Empresa...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown EMPRESAS

const DetallePl = ({elemento, indice, handleChange}) => {
  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMetodo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrTarea}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrFrecuencia}</td>
      {/* <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaProx}</td> */}
    </tr>
  )
};
const ListaPl = ({list, handleChange}) => {
    const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} key={i} indice={i}
      handleChange={handleChange}/>);
    return(
      <tbody className=''>
        {nivel1Detalle}
      </tbody>
    )
  };

//FIN Lista de mecanismos

class ProgProyec2 extends React.Component {
  state={list: this.props.allPlantaRtes1.allPlantaRtes?this.props.allPlantaRtes1.allPlantaRtes:[],
    argsDocum: {descrEmpresa: "Seleccionar Empresa...", desde: this.props.fechaHoy, hasta: this.props.fechaFin},
      permiteUpdate: true, confirmaAct: false, open: false, argsBuscProg: {}, 
      argsQuery: `{"$unwind": "$secciones"},
        {"$unwind": "$secciones.equipos"},
        {"$unwind": "$secciones.equipos.componentes"},
        {"$unwind": "$secciones.equipos.componentes.mecanismos"},
        {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
        {$project: {idPlanta: '$_id', descrEmpresa: 1, codPlanta:1, descrPlanta: 1, 
          codSeccion: '$secciones.codSeccion',
          descrSeccion: '$secciones.descrSeccion',
          codEquipo: '$secciones.equipos.codEquipo',
          descrEquipo: '$secciones.equipos.descrEquipo',
          nombreUsuario: '$secciones.equipos.nombreUsuario',
          cedula: '$secciones.equipos.cedula',
          acumulado: '$secciones.equipos.acumulado',
          horasKmPorDia: '$secciones.equipos.horasKmPorDia',
          codComponente: '$secciones.equipos.componentes.codComponente',
          descrComponente: '$secciones.equipos.componentes.descrComponente',
          codMecanismo: '$secciones.equipos.componentes.mecanismos.codMecanismo',
          descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
          descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
          abrevUnidad: '$secciones.equipos.componentes.mecanismos.abrevUnidad',
          tipoFrecuencia: '$secciones.equipos.componentes.mecanismos.tipoFrecuencia',
          fechaProx: '$secciones.equipos.componentes.mecanismos.programacion.fechaProx',
          acumProx: '$secciones.equipos.componentes.mecanismos.programacion.acumProx',  
          descrMetodo: '$secciones.equipos.componentes.mecanismos.programacion.descrMetodo',
          descrTarea: '$secciones.equipos.componentes.mecanismos.programacion.descrTarea',
          descrFrecuencia: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuencia',
          descrFrecuenciaPre: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuenciaPre',
          cantidad: '$secciones.equipos.componentes.mecanismos.programacion.cantidad',
          puntosLub: '$secciones.equipos.componentes.mecanismos.programacion.puntosLub',
          minutos: '$secciones.equipos.componentes.mecanismos.programacion.minutos'
        }}`
    }

  handleChange = async (ev, indice) => {
    
    if(ev.target.name==="descrEmpresa"||ev.target.name==="desde"||ev.target.name==="hasta"){
      const argsDocum = this.state.argsDocum
      argsDocum[ev.target.name] = ev.target.value
      let argsBuscar=""
      if(ev.target.name==="descrEmpresa"){
        argsBuscar += `'descrEmpresa': '${ev.target.value}'`
      }else{
        argsBuscar += `'descrEmpresa': '${argsDocum.descrEmpresa}'`
      }
      if(this.props.argsBuscProg.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.props.argsBuscProg.descrPlanta}/i`
      }
      if(this.props.argsBuscProg.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.props.argsBuscProg.descrSeccion}/i`
      }
      if(this.props.argsBuscProg.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.props.argsBuscProg.descrEquipo}/i`
      }
      if(this.props.argsBuscProg.descrComponente){
        argsBuscar += `, 'descrComponente': /${this.props.argsBuscProg.descrComponente}/i`
      }
      if(this.props.argsBuscProg.descrMecanismo){
        argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscProg.descrMecanismo}/i`
      }


      // let argsBuscarF = ""
      // if(ev.target.name==="descrEmpresa"){
      //   argsBuscarF = `${argsBuscar}, fechaProx: { $lte: '${argsDocum.hasta}' }`
      // }else{
      //   if(ev.target.name==="desde"){
      //     argsBuscarF = `${argsBuscar}, fechaProx: { $lte: '${argsDocum.hasta}' }`
      //   }else{
      //     argsBuscarF = `${argsBuscar}, fechaProx: { $lte: '${ev.target.value}' }`
      //   }
      // }
      // argsBuscar += `,
      //   $or: [
      //     { tipoFrecuencia: "Calendario", ${argsBuscarF}},
      //     { tipoFrecuencia: {$ne: "Calendario"}, numCarta: "SI" }
      //   ]
      // `
      let argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}

      await this.props.allPlantaRtes1.refetch(argsBuscarPl)
      if(this.props.allPlantaRtes1.allPlantaRtes){
        this.setState({list: 
          this.props.allPlantaRtes1.allPlantaRtes?this.props.allPlantaRtes1.allPlantaRtes:[]
        })
      }
      this.setState({argsDocum});
    }
  }

  handleSubmit = async (ev, list1, argsDocum)=>{
    let list = list1
// console.log(list)
    if(list.length>0){
      document.body.style.cursor = 'wait'

      //Archivo Excel
      let xlsString = []
      let xlsString1 = []
      xlsString1 = ['Año', 'Mes', 'Día', 'Planta', 'Sección', 'Equipo', 'Componente',
        'Mecanismo', 'Método', 'Tarea', 'Frecuencia', 'Lubricante', 'Cantidad', 'Und', 'Puntos', 'Minutos']
      xlsString.push(xlsString1)
      xlsString1 = []

      let xlsString2 = []
      xlsString2 = ['Año', 'Mes', 'Día', 'Planta', 'Sección', 'Equipo', 'Componente',
        'Mecanismo', 'Método', 'Tarea', 'Frecuencia', 'Lubricante', 'Cantidad', 'Und', 'Puntos', 'Minutos']


      let allFrecuencia = this.props.allFrecuencia.allFrecuencia

      for (let iiii=0;iiii<list.length;iiii++){
        let numProgs=0
        let indexFre=0
        let cantidadFreAcum = 0

        if(list[iiii].tipoFrecuencia==='Calendario'){
          if(list[iiii].descrFrecuencia==='Predictiva'){
            indexFre = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===list[iiii].descrFrecuenciaPre )
          }else{
            indexFre = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===list[iiii].descrFrecuencia )
          }
          let cantidadFre = allFrecuencia[indexFre].cantidad
          let fechaHasta = argsDocum.hasta
          let fechaNum = 0
          let fechaHastaNum = parseInt((new Date(fechaHasta).getTime()), 10)
          do {
            let fechaDesde = moment(argsDocum.desde).format('YYYY-MM-DD')
            let fechaFin = moment()
            

            numProgs+=1;
            cantidadFreAcum = cantidadFreAcum + cantidadFre

            if(list[iiii].descrFrecuencia==='Diario'){
              fechaFin = moment(argsDocum.desde).add(cantidadFreAcum, 'd').format('YYYY-MM-DD')
            }else{
              fechaFin = moment(argsDocum.desde).add(cantidadFreAcum, 'd').format('YYYY-MM-DD')
            }
            fechaNum = parseInt((new Date(fechaFin).getTime()), 10)
          } while (fechaHastaNum >= fechaNum);
        }else{
          numProgs=1
        }
        cantidadFreAcum = 0
      
        for(let ii=0;ii<numProgs;ii++){
          let campoAgno = ''
          let campoMes = ''
          let campoDia= ''
          let fechaFin = moment()
          let fechaDesde = moment(argsDocum.desde).format('YYYY-MM-DD')

          if(list[iiii].tipoFrecuencia==='Calendario'){
            
            if(list[iiii].descrFrecuencia==='Predictiva'){
              indexFre = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===list[iiii].descrFrecuenciaPre )
            }else{
              indexFre = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===list[iiii].descrFrecuencia )
            }
          
            if(list[iiii].descrFrecuencia==='Diario'){
              if(ii===0){
                campoAgno = fechaDesde.substring(0, 4)
                campoMes = fechaDesde.substring(5, 7)
                campoDia = fechaDesde.substring(8, 10)
              }else{
                fechaFin = moment(fechaDesde).add(cantidadFreAcum, 'd').format('YYYY-MM-DD')                
                
                campoAgno = fechaFin.substring(0, 4)
                campoMes = fechaFin.substring(5, 7)
                campoDia = fechaFin.substring(8, 10)
              }
            }else{
              if(ii===0){
                campoAgno = fechaDesde.substring(0, 4)
                campoMes = fechaDesde.substring(5, 7)
                campoDia = fechaDesde.substring(8, 10)
              }else{
                fechaFin = moment(fechaDesde).add(cantidadFreAcum, 'd').format('YYYY-MM-DD')
                
                campoAgno = fechaFin.substring(0, 4)
                campoMes = fechaFin.substring(5, 7)
                campoDia = fechaFin.substring(8, 10)  
              }             
            }      

            let cantidadFre = allFrecuencia[indexFre].cantidad   
            cantidadFreAcum=cantidadFreAcum + cantidadFre
          }else{
            campoAgno = fechaDesde.substring(0, 4)
            campoMes = fechaDesde.substring(5, 7)
            campoDia = fechaDesde.substring(8, 10)
          }

          xlsString1 = [campoAgno, campoMes, campoDia, list[iiii].descrPlanta,
          list[iiii].descrSeccion, list[iiii].descrEquipo, list[iiii].descrComponente, list[iiii].descrMecanismo, 
          list[iiii].descrMetodo, list[iiii].descrTarea, list[iiii].descrFrecuencia, list[iiii].descrLubricante, list[iiii].cantidad, 
          list[iiii].abrevUnidad, list[iiii].puntosLub, list[iiii].minutos]

          xlsString.push(xlsString1)
          console.log(xlsString1)

          xlsString1 = []
        } 
        
        if(list.length>80000){
          if(iiii===parseInt(list.length/2)){
            var wb = XLSX.utils.book_new();

            wb.Props = {
              Title: "SheetJS Tutorial",
              Subject: "Test",
              Author: "Red Stapler",
              CreatedDate: new Date(2017,12,19)
            };

            wb.SheetNames.push("Proyectado");

            let ws_data = xlsString;
            xlsString = []

            xlsString.push(xlsString2)

            let ws = XLSX.utils.aoa_to_sheet(ws_data);

            wb.Sheets["Proyectado"] = ws;

            let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

            function s2ab(s) { 
              let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
              let view = new Uint8Array(buf);  //create uint8array as viewer
              for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
              return buf;    
            }

            saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Proyectado1_' + list[iiii].descrEmpresa+'.xlsx');

            //FIN Exportar a XLS
          }
        }

        if(iiii===list.length-1){
          var wb = XLSX.utils.book_new();

          wb.Props = {
            Title: "SheetJS Tutorial",
            Subject: "Test",
            Author: "Red Stapler",
            CreatedDate: new Date(2017,12,19)
          };

          wb.SheetNames.push("Proyectado");

          let ws_data = xlsString;

          let ws = XLSX.utils.aoa_to_sheet(ws_data);

          wb.Sheets["Proyectado"] = ws;

          let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});

          function s2ab(s) { 
            let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
            let view = new Uint8Array(buf);  //create uint8array as viewer
            for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
            return buf;    
          }

          saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Proyectado2_' + list[iiii].descrEmpresa+'.xlsx');



          //FIN Exportar a XLS
        }

      }


      
      document.body.style.cursor = 'default'

      this.setState({open: false})
    }else{
      alert("!! No existen registros para programar !!")
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){
      console.log("1111")
      this.setState({open: true})
    }else{
      console.log("2222")
      this.setState({open: false})
    };
    if(btnPress==="No"){
      console.log("3333")
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      console.log("4444")
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  async componentDidUpdate(prevProps){
    if(this.props.argsBuscProg!==this.state.argsBuscProg){
      let argsBuscar=""
      argsBuscar += `'descrEmpresa': '${this.state.argsDocum.descrEmpresa}'`
      if(this.props.argsBuscProg.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.props.argsBuscProg.descrPlanta}/i`
      }
      if(this.props.argsBuscProg.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.props.argsBuscProg.descrSeccion}/i`
      }
      if(this.props.argsBuscProg.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.props.argsBuscProg.descrEquipo}/i`
      }
      if(this.props.argsBuscProg.descrComponente){
        argsBuscar += `, 'descrComponente': /${this.props.argsBuscProg.descrComponente}/i`
      }
      if(this.props.argsBuscProg.descrMecanismo){
        argsBuscar += `, 'descrMecanismo': /${this.props.argsBuscProg.descrMecanismo}/i`
      }
      // if(this.props.argsBuscProg.nombreUsuario){
      //   argsBuscar += `, 'nombreUsuario': /${this.props.argsBuscProg.nombreUsuario}/i`
      // }
      // argsBuscar += `,
      //   $or: [
      //     { tipoFrecuencia: "Calendario", fechaProx: { $lte: '${this.state.argsDocum.hasta}' } },
      //     { tipoFrecuencia: {$ne: "Calendario"}, numCarta: "SI" }
      //   ]
      // `
      let argsBuscarPl = {tipoqry: `[${this.state.argsQuery}, {$match: {${argsBuscar}}}]`}
// console.log(argsBuscarPl)
      await this.props.allPlantaRtes1.refetch(argsBuscarPl)
      if(this.props.allPlantaRtes1.allPlantaRtes){
        this.setState({argsBuscProg: this.props.argsBuscProg})
        if(this.props.allPlantaRtes1.allPlantaRtes&&prevProps.allPlantaRtes1.allPlantaRtes){
          if((this.props.allPlantaRtes1.allPlantaRtes!==prevProps.allPlantaRtes1.allPlantaRtes)||!this.state.list){
            this.setState({list: 
              this.props.allPlantaRtes1.allPlantaRtes?this.props.allPlantaRtes1.allPlantaRtes:[]
            })
          }
        }
      }
// console.log("XXXXXXX")      
    }
  }

  render(){
    const {list, argsDocum, permiteUpdate, confirmaAct, open} = this.state;
    console.log(open)
    // const a250110 = autorizacUA.findIndex( autorizac => autorizac === "250110" );
    let mensaje = "Generar Excel"
    let imgIcon = "images/documento_32.png"
    
    let list1 = [], list2 = []
    if(this.props.allEmpresa.allEmpresa){list2 = this.props.allEmpresa.allEmpresa}
// console.log(list)
    return (
      // <div>
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, list, argsDocum):()=>{}}>
            <div className="ui four column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '35%', paddingLeft: '1.2em'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Empresa
                  </p>
                  <Form.Field>
                    <ListaEmp styles={this.props.styles} list={list2} handleChange={this.handleChange} />
                  </Form.Field>
                </div>

                <div className="column" style={{width: '15%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Desde
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="desde" id="desde" value={argsDocum.desde} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '15%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Hasta
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="hasta" id="hasta" value={argsDocum.hasta} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '35%', paddingTop: '0.1em'}}>
                  <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
              </div>
            </div>
            <div>
              <div style={{height: '36em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Planta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Sección</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '16%'}}>Equipo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '18%'}}>Componente</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '18%'}}>Mecanismo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Metodo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Tarea</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Frecuencia</th>
                      {/* <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Fecha prox.</th> */}
                     </tr>
                  </thead>
                  <ListaPl list={list} handleChange={this.handleChange}/>
                </table>
                <p></p>
              </div>
            </div>
          </Form>
        </div>
      // </div>
    )
  }
};

export default compose(
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),

  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.query.allFrecuencia, {name:'allFrecuencia'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(ProgProyec2)
